/* global Web3 */
const web3 = new Web3();

export default web3;
